<template>
    <div>        
        <div class="row">   

            <div style="width: 70%;">
                <div class="col-xs-12 col-md-12 offset-md-2 block">
                    <div class="wrapper-progressBar">
                        <ul class="progressBar">
                            <li class="active">Añade Tu Plataforma</li>
                            <li class="active">Añade Tus Canales</li>
                            <li class="active">Selecciona un Video</li>
                            <li>¡Genera Tus Ideas!</li>
                        </ul>
                    </div>
                </div>
            </div>
                    
            <div class="jumbotron bg-light" style="width: 100%; margin-top: 10px;">

                <router-link style="margin-top: -60px;" to="/canales" class="btn btn-outline-dark"><span class="mdi mdi-keyboard-return"></span> Regresar a Canales</router-link>
                <br><br>
                <h1 style="margin-top: -35px;" class="display-6">Listado de tus videos</h1>

                <p class="lead" v-if="videos.length <= 0">
                    <b-skeleton animation="fade" width="85%" v-if="estado_peticion"></b-skeleton>
                    <b-skeleton animation="fade" width="55%" v-if="estado_peticion"></b-skeleton>
                    <b v-else>Añade tu canal primero para ver el listado de tus videos.</b>
                </p>
                <p v-else style="font-weight: bold;">
                    ¡Selecciona un video para que nuestro bot lea tus comentarios y genere nuevas ideas!
                </p>                            
                            
                <div>

                    <div  v-if="videos.length > 0" class="row">
                        <div class="col-md-4 mb-3" v-for="video in videos" v-bind:key="video" >
                            <div class="card" style="cursor: pointer;" @click="navegacion('generar_ideas', video.identificador_post, video.id)">
                                <img :src="video.img" class="card-img-top" width="300px" height="200px">
                                <div class="card-body">
                                    <h5 class="card-title text-truncate" style="max-width: 330px;">{{ video.titulo }}</h5>
                                    <a href="#" class="badge badge-info"><span class="mdi mdi-calendar-clock"></span> {{ video.fecha_publicacion }}</a>
                                </div>
                                <b-button variant="outline-dark"><span class="mdi mdi-robot"></span> Generar Ideas</b-button>
                                <br>
                            </div>                           
                        </div>                            
                    </div>
                    <div class="card" v-else>
                        <div class="card-body">
                            <b-skeleton animation="fade" width="85%" v-if="estado_peticion"></b-skeleton>
                            <b-skeleton animation="fade" width="55%" v-if="estado_peticion"></b-skeleton>
                            <b-skeleton animation="fade" width="70%" v-if="estado_peticion"></b-skeleton>
                            <b v-else>Aún no has agregado un Canal :(!</b>
                        </div>
                    </div>                    

                </div>

            </div>  
            
        </div>        
    </div>
</template>
<script>

import {headers} from './../../api/headers'
import {configApi} from './../../api/configApi'

export default {
    name: 'dashboard',
    data: () => ({        
        videos: [],  
        estado_peticion: true,      
    }),
    mounted() {
        this.getListadoVideos()
    },
    methods: {
        async getListadoVideos() {

            return await this.axios.get(configApi+'listado_posts_videos/'+this.$route.params.usuario, {headers})
            .then(response => {
                this.videos = response.data;
                this.loading = false 
            })

        },       
        navegacion(menu, videoId, idPosts) {
            this.$router.push('/'+menu+'/'+this.$route.params.usuario+'/'+videoId+'/'+idPosts)
        },
    }
}
</script>
<style>
.wrapper-progressBar {
    width: 100%;
}

.progressBar li {
    list-style-type: none;
    float: left;
    width: 25%;
    position: relative;
    text-align: center;
}

.progressBar li:before {
    content: " ";
    line-height: 30px;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    border: 1px solid #ddd;
    display: block;
    text-align: center;
    margin: 0 auto 10px;
    background-color: white
}

.progressBar li:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 4px;
    background-color: #ddd;
    top: 15px;
    left: -50%;
    z-index: -1;
}

.progressBar li:first-child:after {
    content: none;
}

.progressBar li.active {
    color: dodgerblue;
}

.progressBar li.active:before {
    border-color: dodgerblue;
    background-color: dodgerblue
}

.progressBar .active:after {
    background-color: dodgerblue;
}
</style>